import PersonalNavigationConfig from './navigation'
import PersonalRouterConfig from './router'

const PersonalConfig = {
	navigation: [PersonalNavigationConfig],
	router: PersonalRouterConfig
}

export default PersonalConfig
